import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form, ErrorMessage, FieldArray } from 'formik';
import { MdAdd, MdRemove } from 'react-icons/md';
import { FaLocationArrow } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { sendData } from '../../redux/actions/api/SendData';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import Loading from '../../components/loading/Loading';
import TextErrorMessage from '../../components/message/TextErrorMessage';
import {
  checkIfFilesAreCorrectType,
  checkIfFilesAreTooBig,
} from '../../utils/function';

export default function NewSlides() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accessToken } = useSelector((state) => state?.auth);
  const { loading, error } = useSelector((state) => state?.api);
  // ----------------------------------------------------------------------------------->
  useEffect(() => {
    error && toast.error(error);
  }, [dispatch, error, loading]);
  // ----------------------------------------------------------------------------------->
  const initialValues = {
    // initial Values input felids
    images: [{ image: '' }],
  };
  // ----------------------------------------------------------------------------------->
  const validationSchema = Yup.object({
    // validation and check input is not empty
    images: Yup.array().of(
      Yup.object().shape({
        image: Yup.mixed()
          .required(`image is required`)
          .test(
            'fileSize',
            'File size too large, max file size is 2 Mb',
            (value) => !value || checkIfFilesAreTooBig(value)
          )
          .test(
            'fileFormat',
            'Uploaded file has unsupported format.',
            (value) => !value || checkIfFilesAreCorrectType(value)
          ),
      })
    ),
  });
  // ----------------------------------------------------------------------------------->
  const onSubmit = (values) => {
    // handel to modify principle
    var data = new FormData();
    for (let i = 0; i < values?.images.length; i++) {
      data.append(`slider[${i}]`, values?.images[i].image || []);
    }
    dispatch(sendData(`slides`, accessToken, data, navigate, '/slides'));
  };
  return (
    <>
      <Loading isLoading={loading} />
      <Breadcrumb
        title='New a slides'
        textActive='New'
        items={[{ title: 'Slides' }]}
      />
      <div className='card rounded-1 mb-4 p-3'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {(formik) => {
            return (
              <Form>
                <FieldArray name='images'>
                  {(fieldArrayProps) => {
                    const { push, remove, form } = fieldArrayProps;
                    const { values } = form;
                    const { images } = values;
                    return (
                      <div className='row position-relative'>
                        <div className='col-md-7'>
                          <div className='form-group'>
                            <label htmlFor='image' className='text-muted'>
                              Enter your image{' '}
                              <span className='required'>*</span>
                            </label>
                          </div>
                          {images?.map((image, index) => (
                            <div className='row mb-1' key={index}>
                              <div className='col-md-11'>
                                <div className='form-group'>
                                  <input
                                    className='form-control'
                                    name={`images.${index}.image`}
                                    accept='image/*'
                                    id='image'
                                    onChange={(e) =>
                                      formik.setFieldValue(
                                        `images.${index}.image`,
                                        e.target.files[0]
                                      )
                                    }
                                    type='file'
                                  />
                                  <ErrorMessage
                                    name={`images[${index}].image`}
                                    component={TextErrorMessage}
                                  />
                                </div>
                              </div>
                              {index > 0 && (
                                <div className='col-md'>
                                  <div className='form-group'>
                                    <button
                                      type='button'
                                      className='remove-item btn btn-danger mt-2'
                                      onClick={() => remove(index)}
                                    >
                                      <MdRemove />
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>

                        <div className='col-md'>
                          <div className='form-group'>
                            <button
                              type='button'
                              className='add-item btn btn-success'
                              onClick={() => push('')}
                            >
                              <MdAdd />
                            </button>
                          </div>
                        </div>
                        <div className='col-md-12 mt-3 text-center'>
                          <button
                            className='btn btn-primary btn-user btn-inline'
                            type='submit'
                          >
                            <FaLocationArrow style={{ marginRight: '.5rem' }} />
                            New Slide
                          </button>
                        </div>
                      </div>
                    );
                  }}
                </FieldArray>
              </Form>
            );
          }}
        </Formik>
      </div>
    </>
  );
}
